import React from 'react';
import { columns, rows, cellSize, gridHeight } from '@/constants';

import useGrid from '@/use/useGrid';
import { submitGameMove } from '@/realtime/game-room-actions';

import Column from './Column';
import Cell from './Cell';

const Grid = () => {
  const { scale, x, y } = useGrid();
  const columnWidth = cellSize;
  const cellHeight = cellSize;

  const renderCell = (cIndex: number, rIndex: number) => {
    const cellY = gridHeight - cellHeight * (rIndex + 1);
    const zIndex = rows - rIndex - 1;

    return (
      <Cell
        width={columnWidth}
        height={cellHeight}
        key={`cell-${cIndex}${rIndex}`}
        y={cellY}
        zIndex={zIndex}
        cIndex={cIndex}
        rIndex={rIndex}
      />
    );
  };

  const renderColumn = (_: undefined, cIndex: number) => {
    const handleClick = () => {
      submitGameMove(cIndex).catch(() => {});
    };

    return (
      <Column
        onClick={handleClick}
        x={columnWidth * cIndex}
        key={`col-${cIndex}`}
      >
        {[...Array(rows)].map((_: undefined, rIndex: number) => {
          return renderCell(cIndex, rIndex);
        })}
      </Column>
    );
  };

  return (
    <pixiContainer x={x} y={y} scale={{ x: scale, y: scale }}>
      {[...Array(columns)].map(renderColumn)}
    </pixiContainer>
  );
};

export default Grid;
